import { render, staticRenderFns } from "./updateOrder.vue?vue&type=template&id=6ac3b9a9&scoped=true&"
import script from "./updateOrder.vue?vue&type=script&lang=js&"
export * from "./updateOrder.vue?vue&type=script&lang=js&"
import style0 from "./updateOrder.vue?vue&type=style&index=0&id=6ac3b9a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac3b9a9",
  null
  
)

export default component.exports